module.exports = __webpack_public_path__ + "static/media/PURIFICADORINOX.1db08b89.pdf";